export function isListType(type: string): boolean {
  return type === 'listUnordered' || type === 'listOrdered'
}
